import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=7940e9be&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940e9be",
  null
  
)

export default component.exports